import {getTeamMember} from '@/api/team';
import {useQuery} from '@tanstack/react-query';

export function useTeamMember(id: string | undefined) {
    return useQuery({
        queryKey: ['teamMember', id],
        queryFn: () => getTeamMember(id!),
        enabled: !!id
    });
}
